/**
 * ColbensonTagging Service
 */

(function (itxApp) {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxColbensonTaggingSvc', ItxColbensonTaggingSvc);

    ItxColbensonTaggingSvc.$inject = ['$rootScope','Product'];

    /**
     * Search Factory
     * @constructor
     */
    function ItxColbensonTaggingSvc($rootScope,Product) {
        var _this = this;
        _this.lastSearchTerm = '';
        _this.empathyAPI = null;
        _this.$rootScope = $rootScope;
        _this.docs = [];
        _this.currentPage = 0;  
        _this.ProductClass = Product;
    }

    ItxColbensonTaggingSvc.prototype.getEmpathyAPI = function () {
        var _this = this;
        if (_this.empathyAPI) {
            return new Promise((resolve, reject) => {
                resolve(_this.empathyAPI);
            });
        } else {
            return new Promise((resolve, reject) => {
                inditex.getXconfiguracionValue('COLBENSON_SEARCHBROKER_URL_API', function (status, value) {
                    if (value) {
                        inditex.getXconfiguracionValue('COLBENSON_SEARCHBROKER_URL_JS', function (status, value_js) {
                            $.ajax({
                                type: 'GET',
                                url: value_js + 'empathy.resources.min.js',
                                dataType: 'script',
                                cache: true
                            }).done(function () {
                                _this.empathyAPI = {};
                                _this.empathyAPI.empathyTag = new EmpathyBrokerTAG(value_js).init();   
                                _this.empathyAPI.empathySearch = new EmpathyBrokerSearch(value).init(); 
                                resolve(_this.empathyAPI);
                            });
                        });
                    }
                });
            });
        }

    };

    ItxColbensonTaggingSvc.prototype.getDocs = function () {
        var _this = this;
        return _this.docs;
    };

    ItxColbensonTaggingSvc.prototype.setSearchTerm = function (searchTerm, section, family, subfamily) {
        var _this = this;
        _this.searchTerm = searchTerm;
        _this.section = section;
        _this.family = family;
        _this.subfamily = subfamily;
    };

    ItxColbensonTaggingSvc.prototype.getSearchTerm = function () {
        var _this = this;
        return _this.searchTerm;
    };

    ItxColbensonTaggingSvc.prototype.trackQuery = function (searchData) {};

    ItxColbensonTaggingSvc.prototype.trackClick = function (product, url,page) {
        var _this = this;
        return _this.getEmpathyAPI().done(function (eT) {});
    };

    ItxColbensonTaggingSvc.prototype.trackConversion = function (product) {};

    ItxColbensonTaggingSvc.prototype.search = function (start, rows, filters) {
        var _this = this;
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    };

    ItxColbensonTaggingSvc.prototype.reset = function () {
        var _this = this;
        _this.docs = [];
    };

    ItxColbensonTaggingSvc.prototype.setPage = function(page) {
        var _this = this;
        _this.currentPage = page;
    };
    
    /** Public */
    itxApp.common.ItxColbensonTaggingSvc = ItxColbensonTaggingSvc;

})(window.itxApp);
